import { render, staticRenderFns } from "./SejarahMaster.vue?vue&type=template&id=4742c662&scoped=true"
import script from "./SejarahMaster.vue?vue&type=script&lang=js"
export * from "./SejarahMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742c662",
  null
  
)

export default component.exports